import { twMerge } from 'tailwind-merge'
import type { ButtonSize } from '../index'
import { Kbd } from '../../kbd'

/**
 * The inset is the one space around the chips: above, below, after the last one and between each
 * pair, so the strip reads as evenly set into the button. It grows with the button. Type is the
 * scale's smallest step, one under the label, until 2xl's 15px label leaves room for 13.
 */
const CHIP: Record<NonNullable<ButtonSize>, string> = {
  xs: '[--chip-inset:3px] text-xs',
  sm: '[--chip-inset:3px] text-xs',
  md: '[--chip-inset:4px] text-xs',
  lg: '[--chip-inset:5px] text-xs',
  xl: '[--chip-inset:6px] text-xs',
  '2xl': '[--chip-inset:8px] text-sm',
}

interface HotkeyChipsProps {
  hotkey: string
  size: NonNullable<ButtonSize>
}

/** Kbd fitted to a button: chips inset evenly from its edges, concentric with its corner. */
export function HotkeyChips({ hotkey, size }: HotkeyChipsProps) {
  return (
    <Kbd
      hotkey={hotkey}
      className={twMerge(
        // Pulled into the button's trailing padding so the last chip sits one inset from the edge.
        '-mr-[calc(var(--btn-pad)-var(--chip-inset))] [--kbd-gap:var(--chip-inset)] [--kbd-h:calc(var(--btn-h)-2*var(--chip-inset))]',
        // A step past the button's own hover, so a chip stays distinct at rest and under the pointer.
        '[--kbd-bg:var(--element-active)] [--kbd-ink:currentColor]',
        CHIP[size],
      )}
    />
  )
}
